import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewdatasrcComponent } from '../../pages/viewdatasrc/viewdatasrc.component';
@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {

  @Input() dbName!: string;

  constructor(
    private activeModal: NgbActiveModal,
  ){}

  dismiss() {
    this.activeModal.dismiss();
  }

  confirm(){
    this.activeModal.close('confirm')
  }
}
